// ------------------------------------ dates fetch ------------------------------------
import axios from 'axios'

export const DATES_REQUEST = 'DATES_REQUEST'
export const datesRequest = () => ({
	type: DATES_REQUEST
})

export const DATES_RECEIVE = 'DATES_RECEIVE'
export const datesReceive = dates => ({
	type: DATES_RECEIVE,
	dates
})

export const DATES_ERROR = 'DATES_ERROR'
export const datesError = error => ({
	type: DATES_ERROR,
	error
})

export const datesFetch = (
	counselingCenterUsername,
	consultantUsername,
	serviceId,
	language,
	currency,
	timezone
) => {
	return dispatch => {
		dispatch(datesRequest());

		axios.get(`https://panel.betterpro.app/api/dates`, {
			    headers:{
				    'X-Accept-Language': language,
				    'X-Currency': currency,
				    'X-Timezone': timezone
			    },
				params: {
					counseling_center_username: counselingCenterUsername,
					consultant_username: consultantUsername,
					service_id: serviceId
				}
			})
			.then(response => {
				dispatch(datesReceive(response.data.content))
			})
			.catch(error => {
				dispatch(datesError())
			})
	}
}




